/**
 * A stable id for a photo, so the same image is never sent twice.
 *
 * Hashes the data URL itself — the downscaled base64 string is what actually
 * gets sent, so identical strings are identical requests.
 */

import { sha256 } from "../../lib/crypto/sha256";

export async function hashImage(dataUrl: string): Promise<string> {
  const bytes = new TextEncoder().encode(dataUrl);

  // Web Crypto is native and fast, but only exists in a secure context — and
  // the phone hitting the dev server over http://192.168.x.x is not one. Fall
  // back rather than lose caching exactly where the app is most used.
  const subtle = globalThis.crypto?.subtle;
  if (subtle) {
    try {
      const digest = await subtle.digest("SHA-256", bytes);
      return [...new Uint8Array(digest)]
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
    } catch {
      // Some embedded webviews expose subtle and then refuse to use it.
    }
  }

  return sha256(bytes);
}
